<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <h1 class="text-3xl font-bold text-gray-800">Thank You!</h1>
        <p class="mt-4 text-lg text-gray-600">Thanks for completing our survey!</p>
        <svg class="w-16 h-16 mt-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
    </div>
</template>

<script lang="ts">
export default {
    name: "SuccessPage",
};
</script>